package com.islamicmedia.site.components

import com.islamicmedia.site.util.Utm
import androidx.compose.runtime.Composable
import com.islamicmedia.site.theme.*
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.*

@Composable
fun DisclaimerFooter() {
    // Download the App section (above the footer line)
    Div(attrs = {
        style {
            display(DisplayStyle.Flex)
            justifyContent(JustifyContent.Center)
            alignItems(AlignItems.Center)
            gap(12.px)
            padding(8.px, 20.px)
        }
    }) {
        // iOS - Official App Store badge
        A(
            // Untagged on purpose — Apple ignores utm_*. See Utm.APP_STORE_URL.
            href = Utm.APP_STORE_URL,
            attrs = {
                attr("target", "_blank")
                attr("rel", "noopener noreferrer")
                style {
                    display(DisplayStyle.InlineBlock)
                    property("line-height", "0")
                }
            }
        ) {
            Img(
                src = "https://tools.applemediaservices.com/api/badges/download-on-the-app-store/black/en-us?size=250x83",
                attrs = {
                    attr("alt", "Download on the App Store")
                    style {
                        height(36.px)
                        property("object-fit", "contain")
                    }
                }
            )
        }

        // Android - Google Play badge
        A(
            // The utm string rides inside Play's own &referrer= param — a bare ?utm_source=
            // here would never reach the app. See Utm.playStoreUrl.
            href = Utm.playStoreUrl(source = "web", medium = "footer_badge"),
            attrs = {
                attr("target", "_blank")
                attr("rel", "noopener noreferrer")
                style {
                    display(DisplayStyle.InlineBlock)
                    property("line-height", "0")
                }
            }
        ) {
            Img(
                src = "https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png",
                attrs = {
                    attr("alt", "Get it on Google Play")
                    style {
                        height(52.px)
                        property("object-fit", "contain")
                    }
                }
            )
        }
    }

    Footer(attrs = {
        style {
            property("text-align", "center")
            padding(12.px, 20.px)
            property("border-top", "1px solid rgba(255,255,255,0.15)")
        }
    }) {
        // The "not a substitute…" disclaimer now lives at the bottom of the analysis card
        // (ConcernCard.AnalysisDisclaimer), where it's most relevant, so the footer stays compact.

        // Privacy Policy + Terms links. The privacy link is required on the homepage for Google's
        // OAuth brand verification; both are good practice regardless.
        Div(attrs = {
            style {
                property("margin-top", "8px")
                display(DisplayStyle.Flex)
                justifyContent(JustifyContent.Center)
                alignItems(AlignItems.Center)
                gap(10.px)
            }
        }) {
            A(
                href = "/privacy",
                attrs = {
                    style {
                        fontSize(11.px)
                        color(rgba(255, 255, 255, 0.75))
                        property("text-decoration", "underline")
                    }
                }
            ) { Text("Privacy Policy") }
            Span(attrs = { style { fontSize(11.px); color(rgba(255, 255, 255, 0.4)) } }) { Text("·") }
            A(
                href = "/terms",
                attrs = {
                    style {
                        fontSize(11.px)
                        color(rgba(255, 255, 255, 0.75))
                        property("text-decoration", "underline")
                    }
                }
            ) { Text("Terms of Service") }
        }
    }
}
